<ng-container *transloco="let convert;">
  <app-modal [modalId]="modalId">
    @if (waitingResponse && !successfulResponse) {
      <!-- submitting -->
      <app-action-submitting actionText="{{ convert('vehicles.financeSourcesModal.actionTextSavingCreditLine') }}"></app-action-submitting>
    }

    @if (!waitingResponse && successfulResponse) {
      <!-- success -->
      <app-action-submitted (close)="cancel()" actionText="{{ convert('vehicles.financeSourcesModal.actionTextCreditLine') }}" [tenantName]="tenantName">
      </app-action-submitted>
    }
  </app-modal>
</ng-container>

